export const companyTranslations = {
  en: {
    headline: 'We Make 3D',
    description: 'Our technology specializes in 3D generation, digital humans, and virtual reality. Pioneering a new horizon of machine-human interaction.',
    vision: {
      title: 'Our Vision',
      content: 'To revolutionize human-computer interaction through cutting-edge 3D technology, making digital experiences more natural, immersive, and accessible to everyone.'
    },
    mission: {
      title: 'Our Mission',
      content: 'To develop and deliver innovative 3D solutions that bridge the gap between digital and physical worlds, empowering creators and businesses to build unprecedented interactive experiences.'
    }
  },
  ko: {
    headline: '우리는 만든다 3D를',
    description: '우리의 기술은 3D 생성, 디지털 휴먼 및 가상 현실을 전문으로 합니다. 기계와 인간 상호작용의 새로운 지평을 열어갑니다.',
    vision: {
      title: '우리의 비전',
      content: '최첨단 3D 기술을 통해 인간과 컴퓨터의 상호작용을 혁신하여 디지털 경험을 더욱 자연스럽고 몰입감 있으며 모든 사람이 접근할 수 있도록 만듭니다.'
    },
    mission: {
      title: '우리의 미션',
      content: '디지털 세계와 물리적 세계를 연결하는 혁신적인 3D 솔루션을 개발하고 제공하여 창작자와 기업이 전례 없는 상호작용 경험을 구축할 수 있도록 지원합니다.'
    }
  },
  zh: {
    headline: '我们制作3D',
    description: '我们的技术专注于3D生成、数字人类和虚拟现实。开创机器与人类交互的新领域。',
    vision: {
      title: '我们的愿景',
      content: '通过尖端3D技术革新人机交互，使数字体验更自然、更沉浸、更易于所有人使用。'
    },
    mission: {
      title: '我们的使命',
      content: '开发和提供创新的3D解决方案，架起数字世界和物理世界之间的桥梁，使创作者和企业能够构建前所未有的互动体验。'
    }
  },
  ja: {
    headline: '私たちは3Dを作ります',
    description: '私たちの技術は、3D生成、デジタルヒューマン、バーチャルリアリティを専門としています。機械と人間の相互作用の新たな地平を切り開きます。',
    vision: {
      title: '私たちのビジョン',
      content: '最先端の3D技術を通じて人間とコンピュータの相互作用を革新し、デジタル体験をより自然で没入感のあるものにし、誰もがアクセスしやすいものにすること。'
    },
    mission: {
      title: '私たちのミッション',
      content: 'デジタルと物理的な世界をつなぐ革新的な3Dソリューションを開発・提供し、クリエイターや企業が前例のないインタラクティブな体験を構築できるようにすること。'
    }
  }
};